import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { useAuth } from './auth/auth.service';

import { ThemeProvider, createTheme } from '@mui/material';
import axios from 'axios';
import { useEffect } from 'react';
import Alert from './components/Alert';
import AlertProvider from './context/alert.context';
import { LanguageProvider, useLanguage } from './context/language.context';
import { ModalProvider } from './context/ModalProvider';
import UserContext from './context/user.context';
import Login from './pages/Auth/AuthPage';
import Main from './pages/Main';
import ResetPassword from './pages/ResetPassword';

require('./config/he.locale');

const rtlTheme = createTheme({
  direction: 'rtl',
  typography: { allVariants: { fontFamily: 'Open Sans' } },
  components: {
    MuiTableCell: { defaultProps: { align: 'right' } },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& label': {
            transformOrigin: 'right !important',
            left: 'inherit !important',
            right: '0rem !important',
            fontSize: 'small',
            color: '#807D7B',
            fontWeight: 400,
            overflow: 'unset',
          },
        },
      },
    },
  },
});

const ltrTheme = createTheme({
  direction: 'ltr',
  typography: { allVariants: { fontFamily: 'Open Sans' } },
  components: {
    MuiTableCell: { defaultProps: { align: 'left' } },
  },
});

function AppInner() {
  const { token, login, logout, userId } = useAuth();
  const { isHebrew } = useLanguage();

  useEffect(() => {
    axios.defaults.headers.common['x-client'] = 'experts-web';
  }, []);

  return (
    <ThemeProvider theme={isHebrew ? rtlTheme : ltrTheme}>
      <ModalProvider>
        <AlertProvider>
          <UserContext.Provider value={{ isLoggedIn: !!token, token, userId, login, logout }}>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Login />} />
                {userId && <Route path="/expert" element={<Main />} />}
                <Route path="/reset_password" element={<ResetPassword />} />
                <Route path="*" element={<Login />} />
              </Routes>
            </BrowserRouter>
          </UserContext.Provider>
          <Alert />
        </AlertProvider>
      </ModalProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppInner />
    </LanguageProvider>
  );
}

export default App;
